































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditThequipment from "./edit-thequipment.vue";
import CreateThequipment from "./create-thequipment.vue";
import Auth from "../../../lib/Judgeauthority";
class PageThequipmentRequest extends PageRequest {
  //FilterText: string;
  Mac: string;
  etype: number = 3;
  // locationName:string;
  // IP:string;
  // lotCard:string;
  // remark:string;

  //wId:string;
}
class PageCompanyRequest {
  cId: Number;
  ftId: Number;
  wId: Number;
}
class DataThequipmentRequest {
  Mac: string;
  etype: number;
  cId: Number;
  ftId: Number;
  wId: Number;
  fId: Number;
}

@Component({
  components: { EditThequipment, CreateThequipment },
})
export default class Thequipments extends AbpBase {
  pagerequest: PageThequipmentRequest = new PageThequipmentRequest();
  publicpagerequest: PageThequipmentRequest = new PageThequipmentRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  dataThequipmentRequest: DataThequipmentRequest = new DataThequipmentRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  userName: string;
  cId: Number;
  selwarehouselist = [];
  selfloorlist = [];
  datalist = [];
  showAddButton = false;
  etypelist = [
    { name: "全部", value: "3" },
    { name: "环境温湿度", value: "0" },
    { name: "包芯温湿度", value: "2" },
    // { name: "包芯温湿度(单针)", value: "2" },
    // { name: "包芯温湿度(一拖三)", value: "1" },
  ];

  get list() {
    return this.$store.state.thequipment.list;
  }
  get loading() {
    return this.$store.state.thequipment.loading;
  }
  pageChange(page: number) {
    this.$store.commit("thequipment/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("thequipment/setPageSize", pagesize);
    this.getPage();
  }
  getsearch() {
    this.$store.state.thequipment.currentPage = 1;
    this.getPage();
  }
  async getPage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

    //filters
    await this.$store.dispatch({
      type: "thequipment/getPage",
      data: this.pagerequest,
    });
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  async exportExcel() {
    this.dataThequipmentRequest.etype = this.pagerequest.etype;
    this.dataThequipmentRequest.Mac = this.pagerequest.Mac;
    this.pagerequest.maxResultCount = this.totalCount;
    //filters
    this.datalist = await this.$store.dispatch({
      type: "thequipment/getDataforExcel",
      data: this.pagerequest,
    });
    let str =
      "日期,库区,库房,楼层,设备MAC,烟垛位置,烟叶信息,一号针MAC,二号针MAC,三号针MAC\n";
    if (this.dataThequipmentRequest.etype == 0) {
      str = "日期,库区,库房,楼层,设备MAC,烟垛位置,烟叶信息\n";
    }
    for (let i = 0; i < this.datalist.length; i++) {
      let ftName = "";
      let wName = "";
      let fName = "";
      let scName = "";
      for (let entry of this.factorylist()) {
        if (this.datalist[i].ftId == entry.id) {
          ftName = entry.fName;
          break;
        }
      }
      for (let entry of this.warehouselist()) {
        if (this.datalist[i].wId == entry.id) {
          wName = entry.wName;
          break;
        }
      }
      for (let entry of this.floorlist()) {
        if (this.datalist[i].fId == entry.id) {
          fName = entry.fName;
          break;
        }
      }
      for (let entry of this.smokecriblist()) {
        if (this.datalist[i].scId == entry.id) {
          scName = entry.title;
          break;
        }
      }
      if (this.datalist[i].locationName == null) {
        this.datalist[i].locationName = "";
      } else {
        this.datalist[i].locationName = "\t" + this.datalist[i].locationName;
      }
      let addTime = "\t" + this.datalist[i].addTime.toString().substring(0, 10);
      if (this.datalist[i].etype == 0) {
        str +=
          addTime +
          "," +
          ftName +
          "," +
          wName +
          "," +
          fName +
          "," +
          this.datalist[i].mac +
          "," +
          this.datalist[i].locationName +
          "," +
          scName +
          "\n";
      } else {
        str +=
          addTime +
          "," +
          ftName +
          "," +
          wName +
          "," +
          fName +
          "," +
          this.datalist[i].mac +
          "," +
          this.datalist[i].locationName +
          "," +
          scName +
          "," +
          this.datalist[i].maC1 +
          "," +
          this.datalist[i].maC2 +
          "," +
          this.datalist[i].maC3 +
          "\n";
      }
    }

    str = str.toString().replace(/null/g, "");
    let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str);
    let link = document.createElement("a");
    link.href = uri;
    link.download = "设备数据.csv";
    link.click();
    URL.revokeObjectURL(link.href);
  }
  get pageSize() {
    return this.$store.state.thequipment.pageSize;
  }
  get totalCount() {
    return this.$store.state.thequipment.totalCount;
  }
  get currentPage() {
    return this.$store.state.thequipment.currentPage;
  }
  getuserName() {
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  // get warehouse() {
  //   return this.$store.state.warehouse.list;
  // }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  // get floor() {
  //   return this.$store.state.floor.list;
  // }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist() {
    return this.$store.state.factory.list;
  }
  get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist() {
    return this.$store.state.smokecrib.list;
  }
  filtersmoklist() {
    return this.$store.state.smokecrib.leaffilterlist;
  }
  smokeleaflist() {
    return this.$store.state.smokeleaf.list;
  }
  get threshold() {
    return this.$store.state.threshold.list;
  }
  thresholdlist() {
    return this.$store.state.threshold.list;
  }

  selCompany(value: Number) {
    this.pagecompanyrequest.cId = value;
    this.dataThequipmentRequest.cId = value;
    this.getfactory();
    this.getwarehouse();
    this.getfloor();
    this.getPage();
  }
  selfactory(value: Number) {
    this.pagecompanyrequest.ftId = value;
    this.dataThequipmentRequest.ftId = value;
    if (value != 0) {
      this.getselwarehouse();
    } else {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
    //this.getfloor();
    this.$store.state.thequipment.currentPage = 1;
    this.getPage();
  }
  selwarehouse(value: Number) {
    this.pagecompanyrequest.wId = value;
    this.dataThequipmentRequest.wId = value;
    if (value != 0 && value != undefined) {
      this.getselfloor();
    } else {
      this.selfloorlist = [];
    }
    this.$store.state.thequipment.currentPage = 1;
    this.getPage();
  }
  selfloor(value: Number) {
    this.dataThequipmentRequest.fId = value;
    this.$store.state.thequipment.currentPage = 1;
    this.getPage();
  }
  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist();
        for (let entry of flist) {
          if (Id == entry.id) {
            Id = entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "库房",
      key: "wId",
      render: (h, params) => {
        let wId = params.row.wId;
        let clist = this.warehouselist();
        //console.log(clist);
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if (wId == entry.id) {
            wId = entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      render: (h, params) => {
        let fId = params.row.fId;
        let clist = this.floorlist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if (fId == entry.id) {
            fId = entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key: "mac",
      // sortable: true,
    },
    {
      title: "烟叶",
      key: "scId",
      render: (h, params) => {
        let restr = "";
        let scId = params.row.scId;
        let clist = this.smokecriblist();
        if (params.row.cId == 4) {
          for (let entry of clist) {
            if (scId == entry.id && scId != 0) {
              restr = entry.title;
              break;
            }
          }
        } else {
          let slist = this.filtersmoklist();
          for (let entry of slist) {
            if (scId == entry.id) {
              restr = entry.title;
              break;
            }
          }
          if (restr == "" && restr == null) {
            for (let entry of clist) {
              if (scId == entry.id && scId != 0) {
                restr = entry.title;
                break;
              }
            }
          }
        }
        return h("span", restr);
      },
    },
    {
      title: "垛位号",
      key: "locationName",
    },
    // {
    //   title: "采集间隔",
    //   key: "acquisitionInterval",
    // },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        let strupdate = h(
          "Button",
          {
            props: {
              type: "primary",
              size: "small",
            },
            style: {
              marginRight: "5px",
            },
            on: {
              click: () => {
                //console.log(params.row);
                this.$store.commit("thequipment/edit", params.row);
                this.edit();
              },
            },
          },
          this.L("Edit")
        );
        //判断是否有修改权限
        if (!Auth.getauthority("Pages.Thequipments_Update")) {
          strupdate = null;
        }
        let strdelete = h(
          "Button",
          {
            props: {
              type: "error",
              size: "small",
            },
            on: {
              click: async () => {
                this.$Modal.confirm({
                  title: "提示",
                  content: "确认删除该条数据？",
                  okText: "删除",
                  cancelText: "取消",
                  onOk: async () => {
                    await this.$store.dispatch({
                      type: "thequipment/delete",
                      data: params.row,
                    });
                    await this.getPage();
                  },
                });
              },
            },
          },
          "删除"
        );
        //判断是否有删除权限
        if (!Auth.getauthority("Pages.Thequipments_Delete")) {
          strdelete = null;
        }
        return h("div", [strupdate, strdelete]);
      },
    },
  ];
  ///根据权限返回列数据
  get filterColumns() {
    if (
      !Auth.getauthority("Pages.Thequipments_Update") &&
      !Auth.getauthority("Pages.Thequipments_Delete")
    ) {
      return this.columns.filter((col) => col.key !== "Actions");
    }
    return this.columns;
  }
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getselwarehouse() {
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  async getththreshold() {
    //阈值方案
    //filters
    await this.$store.dispatch({
      type: "ththreshold/getPage",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory() {
    //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getgwequipment() {
    //网关
    //filters
    await this.$store.dispatch({
      type: "gwequipment/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getsmokecrib() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfiltersmokList() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getlistfilter",
      data: this.pagecompanyrequest,
    });
  }
  async getsmokeleaf() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokeleaf/getAlllist",
      data: this.pagecompanyrequest,
    });
  }
  created() {
    this.$store.state.thequipment.pageSize = 10;
    this.$store.state.thequipment.currentPage = 1;
    this.$store.state.thequipment.totalCount = 0;
    this.getuserName();
    this.getwarehouse();
    this.getfloor();
    this.getfactory();
    this.getththreshold();
    this.getgwequipment();
    this.getsmokecrib();
    this.getfiltersmokList();
    // this.getsmokeleaf();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }
    this.getPage();
    if (Auth.getauthority("Pages.Thequipments_Create")) {
      this.showAddButton = true;
    }
  }
}
